import type { StoreType } from '../../types';
import { capitalizeFirstLetter } from '../capitalizeFirstLetter';
import { convertToTitleCase } from '../convertToTitleCase';

export type StoreData = {
  _geoloc: StoreType['_geoloc'];
  address: StoreType['address'];
  displayName: StoreType['displayName'];
  features: StoreType['features'];
  openingHours: StoreType['openingHours'];
};

export function addStoreJsonLd(store: StoreData, url: string) {
  const { displayName, address, openingHours, _geoloc: geoLoc, features } = store;

  return {
    __html: JSON.stringify(
      {
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: displayName,
        address: {
          '@type': 'PostalAddress',
          streetAddress: address.streetName,
          addressLocality: address.town,
          addressRegion: address.province || null,
          postalCode: address.postalCode,
          addressCountry: address.country || null,
        },
        telephone: address.phone || null,
        openingHours:
          openingHours?.map(({ day, openingTime, closingTime }) => ({
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: `https://schema.org/${capitalizeFirstLetter(day.toLowerCase())}`,
            opens: openingTime,
            closes: closingTime,
          })) || null,
        geo: {
          '@type': 'GeoCoordinates',
          latitude: geoLoc?.lat || null,
          longitude: geoLoc?.lng || null,
        },
        url,
        sameAs: [
          'https://twitter.com/clarksshoes',
          'https://www.pinterest.com/clarksusa/',
          'https://www.youtube.com/user/clarksshoes',
          'https://www.facebook.com/ClarksShoes',
          'https://www.instagram.com/clarksshoes',
        ],
        image: 'https://clarks.a.bigcontent.io/v1/static/ClarksLogo_Update',
        additionalType: 'https://schema.org/ShoeStore',
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Store Services',
          itemListElement:
            features
              ?.filter((feature) => feature.isActive)
              .map(({ name }) => ({
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: convertToTitleCase(name),
                },
              })) || null,
        },
      },
      null,
      2,
    ),
  };
}
